import { BOOKING_APIS } from "@/api_framework/api_config";
import { IUserBookingsListResponse } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { appendBookingList, setUserBookingList } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";

AxiosCurlirize(axios, () => {});
type BookingsPaginateOptions = {
  page: number;
  limit: number;
  filter_by: string;
  append: boolean;
};

export const useUserBookingsListAPI = () => {
  const { getRouteKey } = useRouter();
  const { sendCurl } = useCurlLogger();
  const { routeState: customerProfileRouteState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { appointmentFilter } = customerProfileRouteState.state as ICustomerProfileState;

  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const toggleLoading = (toggleState: boolean) => {
    dispatch(
      setLoading({
        key: "isCustomerBookingsFetchInProgress",
        status: toggleState,
      }),
    );
  };
  const execute = useCallback(
    async (userId: string, petId: string, paginationOptions?: BookingsPaginateOptions) => {
      const page = paginationOptions && paginationOptions?.page ? paginationOptions?.page : 1;
      const filterBy =
        paginationOptions && paginationOptions?.filter_by ? paginationOptions?.filter_by : appointmentFilter; // Default is total for invalid data form.
      const limit = paginationOptions && paginationOptions?.limit ? paginationOptions?.limit : 10; // default limit is set to 10
      toggleLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        return await axios
          .get(BOOKING_APIS?.LIST_BOOKINGS?.baseURL ?? "", {
            params: {
              user_id: userId,
              page_num: page,
              limit: limit,
              filter_key: filterBy,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IUserBookingsListResponse>) => {
            toggleLoading(false);
            if (res.data.status === true && res.data) {
              if (paginationOptions && paginationOptions?.append) {
                dispatch(
                  appendBookingList({
                    data: res.data.data,
                  }),
                );
              } else {
                dispatch(
                  setUserBookingList({
                    data: res.data.data,
                  }),
                );
              }
              /* Handed back to the caller as well as the store: the PWL -> EMR-tab
                 voice check needs the fresh booking statuses inline, before the
                 store round-trip has re-rendered anything. */
              return res.data.data;
            }
            dispatch(
              setUserBookingList({
                data: {
                  count: 0,
                  data: [],
                },
              }),
            );
            return null;
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setUserBookingList({
                data: {
                  count: 0,
                  data: [],
                },
              }),
            );
            toggleLoading(false);
            if (e.response.status === 400) {
              dispatch(
                setUserBookingList({
                  data: {
                    count: 0,
                    data: [],
                  },
                }),
              );
            }
            return null;
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch],
  );
  return execute;
};
